(function () {
  var cfgEl = document.getElementById('fitaz-peri-recipe-hero-ab-analytics-config');
  if (!cfgEl) return;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var GA4 = CFG.ga4_id || 'G-Y0VT2QGQW7';
  var COOKIE = 'peri_recipe_hero_ab';
  var STORAGE_KEY = 'peri_recipe_hero_ab';
  var HERO_SELECTOR = CFG.hero_selector || '[data-peri-recipe-hero]';
  var STATEMENT_SELECTOR = CFG.statement_selector || '[data-peri-recipe-statement]';
  var SCROLL_MARKS = [25, 50, 75, 90, 100];

  function readCookie(name) {
    try {
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var chunk = parts[i].trim();
        if (chunk.indexOf(name + '=') === 0) {
          return decodeURIComponent(chunk.slice(name.length + 1));
        }
      }
    } catch (e) {}
    return '';
  }

  function readStorage() {
    try {
      var value = window.localStorage.getItem(STORAGE_KEY) || '';
      if (value === 'control' || value === 'variant') return value;
    } catch (e) {}
    return '';
  }

  function resolveArm() {
    if (window.__fitazPeriRecipeHeroAb) {
      var known = window.__fitazPeriRecipeHeroAb.arm;
      if (known === 'control' || known === 'variant') return known;
    }
    var root = document.documentElement;
    if (root && root.classList) {
      if (root.classList.contains('peri-recipe-hero-ab--b')) return 'variant';
      if (root.classList.contains('peri-recipe-hero-ab--a')) return 'control';
    }
    var stored = readCookie(COOKIE);
    if (stored !== 'control' && stored !== 'variant') stored = readStorage();
    if (stored === 'control' || stored === 'variant') return stored;
    // Test off / unassigned: page renders control copy via the CSS fallback.
    return 'control';
  }

  var ARM = resolveArm();

  function activeStatement() {
    try {
      var hero = document.querySelector(HERO_SELECTOR);
      if (!hero) return '';
      var wanted = ARM === 'variant' ? 'b' : 'a';
      var el = hero.querySelector(STATEMENT_SELECTOR + '[data-peri-ab-copy="' + wanted + '"]');
      if (!el) el = hero.querySelector(STATEMENT_SELECTOR);
      return el ? (el.textContent || '').trim() : '';
    } catch (e) {
      return '';
    }
  }

  function baseParams(extra) {
    return Object.assign(
      {
        send_to: GA4,
        peri_recipe_hero_variant: ARM,
        peri_recipe_hero_statement: activeStatement(),
        page_type: CFG.page_type || '',
        site_market: CFG.site_market
      },
      extra || {}
    );
  }

  function send(name, extra) {
    var params = baseParams(extra);
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        var payload = { event: name };
        Object.keys(params).forEach(function (key) {
          payload[key] = params[key];
        });
        window.dataLayer.push(payload);
      }
    } catch (err) {}
  }

  function once(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
      return true;
    } catch (e) {
      return true;
    }
  }

  function setUserProperties() {
    if (typeof window.gtag !== 'function') return;
    if (ARM !== 'control' && ARM !== 'variant') return;
    try {
      window.gtag('set', 'user_properties', {
        peri_recipe_hero_variant: ARM
      });
      window.__fitazPeriRecipeHeroAb = { arm: ARM };
    } catch (e) {}
  }

  function setClarityTags() {
    function push() {
      try {
        if (typeof window.clarity !== 'function') return false;
        window.clarity('set', 'peri_recipe_hero_variant', ARM);
        window.clarity('set', 'peri_recipe_hero_statement', activeStatement());
        return true;
      } catch (e) {
        return false;
      }
    }
    if (push()) return;
    var attempts = 0;
    var timer = window.setInterval(function () {
      if (push() || ++attempts >= 40) window.clearInterval(timer);
    }, 250);
  }

  function classifyClick(target) {
    if (!target || !target.closest) return null;
    if (target.closest('[data-peri-sticky-cta]')) return 'sticky_cta';
    if (target.closest('[data-peri-plan-cta]')) return 'plan_picker_cta';
    if (target.closest('[data-peri-plan-expand]')) return 'plan_picker_expand';
    if (target.closest('[data-peri-hero-dot]')) return 'slider_dot';
    if (target.closest('[data-peri-reviews-scroll]')) return 'reviews_scroll';
    return null;
  }

  function bindHeroClicks() {
    document.addEventListener(
      'click',
      function (e) {
        var clickTarget = classifyClick(e.target);
        if (!clickTarget) return;

        // The sticky CTA is portaled outside the hero section (and may be moved to
        // <body>), so it can't be matched by hero containment. This script only
        // loads on the recipe template, so any sticky CTA here is ours.
        var isSticky = clickTarget === 'sticky_cta';
        if (!isSticky) {
          var hero = document.querySelector(HERO_SELECTOR);
          if (!hero || !hero.contains(e.target)) return;
        }

        var linkEl = e.target.closest('a[href]');
        send('peri_recipe_hero_click', {
          click_target: clickTarget,
          link_href: linkEl ? linkEl.getAttribute('href') || '' : ''
        });
      },
      true
    );
  }

  function bindScrollDepth() {
    var fired = {};

    function scrollPercent() {
      var doc = document.documentElement;
      var body = document.body;
      var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
      var scrollHeight = Math.max(body.scrollHeight, doc.scrollHeight) - window.innerHeight;
      if (scrollHeight <= 0) return 100;
      return Math.min(100, Math.round((scrollTop / scrollHeight) * 100));
    }

    function onScroll() {
      var pct = scrollPercent();
      SCROLL_MARKS.forEach(function (mark) {
        if (pct < mark || fired[mark]) return;
        fired[mark] = true;
        send('peri_recipe_hero_scroll_depth', { scroll_percent: mark });
      });
      if (fired[100]) {
        window.removeEventListener('scroll', onScroll);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    var viewKey = 'fitaz_peri_recipe_hero_ab_view_' + ARM;
    if (once(viewKey)) {
      setUserProperties();
      setClarityTags();
      send('peri_recipe_hero_view');
    }

    bindHeroClicks();
    bindScrollDepth();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
